/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ShipmentActivityEntryResponse } from "./ShipmentActivityEntryResponse";
import {
  ShipmentActivityEntryResponseFromJSON,
  ShipmentActivityEntryResponseFromJSONTyped,
  ShipmentActivityEntryResponseToJSON,
  ShipmentActivityEntryResponseToJSONTyped,
} from "./ShipmentActivityEntryResponse";

/**
 *
 * @export
 * @interface ShipmentActivityResponse
 */
export interface ShipmentActivityResponse {
  /**
   *
   * @type {Array<ShipmentActivityEntryResponse>}
   * @memberof ShipmentActivityResponse
   */
  activities: Array<ShipmentActivityEntryResponse>;
}

/**
 * Check if a given object implements the ShipmentActivityResponse interface.
 */
export function instanceOfShipmentActivityResponse(
  value: object,
): value is ShipmentActivityResponse {
  if (!("activities" in value) || value["activities"] === undefined)
    return false;
  return true;
}

export function ShipmentActivityResponseFromJSON(
  json: any,
): ShipmentActivityResponse {
  return ShipmentActivityResponseFromJSONTyped(json, false);
}

export function ShipmentActivityResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShipmentActivityResponse {
  if (json == null) {
    return json;
  }
  return {
    activities: (json["activities"] as Array<any>).map(
      ShipmentActivityEntryResponseFromJSON,
    ),
  };
}

export function ShipmentActivityResponseToJSON(
  json: any,
): ShipmentActivityResponse {
  return ShipmentActivityResponseToJSONTyped(json, false);
}

export function ShipmentActivityResponseToJSONTyped(
  value?: ShipmentActivityResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    activities: (value["activities"] as Array<any>).map(
      ShipmentActivityEntryResponseToJSON,
    ),
  };
}
